export default __webpack_public_path__ + "static/media/binance.c2364ac7.svg";